/* tslint:disable */

declare var Object: any;
export interface DigitalToolInterface {
  "name": string;
  "link"?: string;
  "icon"?: string;
  "description"?: string;
  "id"?: number;
}

export class DigitalTool implements DigitalToolInterface {
  "name": string;
  "link": string;
  "icon": string;
  "description": string;
  "id": number;
  constructor(data?: DigitalToolInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DigitalTool`.
   */
  public static getModelName() {
    return "DigitalTool";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DigitalTool for dynamic purposes.
  **/
  public static factory(data: DigitalToolInterface): DigitalTool{
    return new DigitalTool(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DigitalTool',
      plural: 'DigitalTools',
      path: 'DigitalTools',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "link": {
          name: 'link',
          type: 'string'
        },
        "icon": {
          name: 'icon',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/DigitalTool.ts